/**
 * Caché muy simple de peticiones GET, en memoria, viva mientras dura la
 * pestaña (se limpia con una recarga completa, no al navegar entre rutas
 * dentro de la SPA — que es justo el caso que había que cubrir).
 *
 * Antes, el temario (~300 KB) y la lista de temas se volvían a descargar
 * enteros cada vez que se visitaba esa pantalla, aunque los datos no hubieran
 * cambiado desde la última vez en la misma sesión. Y /api/topics se pedía por
 * separado desde dos páginas distintas (examen por tema y preguntas
 * abiertas) sin compartir nada entre ellas.
 *
 * Se guarda la PROMESA, no solo el resultado ya resuelto: si dos componentes
 * piden la misma clave casi a la vez, comparten la petición en curso en vez
 * de disparar dos peticiones idénticas.
 *
 * Deliberadamente NO es una librería como react-query/SWR: para dos casos de
 * uso puntuales, un Map a nivel de módulo es más simple y no añade una
 * dependencia nueva a un proyecto que hasta ahora no tenía ninguna capa de
 * caché de cliente.
 */
const cache = new Map();

export function cachedGet(key, fetcher) {
  if (!cache.has(key)) {
    const promise = fetcher().catch((err) => {
      cache.delete(key); // no cachear fallos: el siguiente intento reintenta de verdad
      throw err;
    });
    cache.set(key, promise);
  }
  return cache.get(key);
}

export function clearApiCache(key) {
  if (key) cache.delete(key);
  else cache.clear();
}
